import ProcessEngineeringContent, {
  ValuesOption,
} from "../../../domains/ProcessEngineering/ProcessEngineeringFormContent";
import ProcessEngineeringEvaluationPayload from "../../../domains/ProcessEngineering/ProcessEngineeringEvaluationPayload";
import processEngineeringReducer from "./reducer";
import {
  openProcessEngineeringModal,
  closeProcessEngineeringModal,
  resetProcessEngineeringEvaluationSubmission,
  setProcessEvaluationData,
  clearProcessEvaluationData,
  closeProcessEngineeringTableModal,
  openProcessEngineeringTableModal,
  submitProcessEngineeringEvaluation,
  submitProcessEngineeringsEvaluationSuccess,
  fetchProcessEngineeringEvaluationStatuses,
  fetchProcessEngineeringEvaluationStatusesSucess,
  fetchProcessEngineeringEvaluationStatusesError,
  showEvaluationDetails,
  hideEvaluationDetails,
} from "./actions";

export interface ProcessEngineeringState {
  processEvaluationData: ProcessEngineeringContent | null
  isProcessEngineeringModalOpen: boolean
  isSubmitting: boolean
  hasSubmissionError: boolean
  submissionProcessEvaluationSuccess: boolean
  isFetchingStatuses: boolean
  hasFetchingStatusesError: boolean
  processEngineeringStatuses: Array<string>
  isProcessEngineeringTableModalOpen: boolean
  isEvaluationDetailsShown: boolean
  selectedEvaluation: ProcessEngineeringEvaluationPayload
}

export const initialState = {
  processEvaluationData: {
    gains: undefined,
    status: "",
    penalties: undefined,
    details: "",
    valuesOption: "gainsOption" as ValuesOption,
    fileIds: [],
    department: "process_engineering",
  },
  isProcessEngineeringModalOpen: false,
  isSubmitting: false,
  hasSubmissionError: false,
  submissionProcessEvaluationSuccess: false,
  isFetchingStatuses: false,
  processEngineeringStatuses: [],
  isProcessEngineeringTableModalOpen: false,
  isEvaluationDetailsShown: false,
  selectedEvaluation: null
};

export default processEngineeringReducer;

export {
  openProcessEngineeringModal,
  closeProcessEngineeringModal,
  resetProcessEngineeringEvaluationSubmission,
  setProcessEvaluationData,
  closeProcessEngineeringTableModal,
  openProcessEngineeringTableModal,
  clearProcessEvaluationData,
  submitProcessEngineeringEvaluation,
  submitProcessEngineeringsEvaluationSuccess,
  fetchProcessEngineeringEvaluationStatuses,
  fetchProcessEngineeringEvaluationStatusesSucess,
  fetchProcessEngineeringEvaluationStatusesError,
  showEvaluationDetails,
  hideEvaluationDetails,
};
